import { useEffect } from 'react';

const CSIDE_SCRIPT_SRC = 'https://7458619530513857536.csidetm.com/client.js';

/**
 * Injects the CSide client.js script (unique identifier for WorkWave) into the
 * document head while a payment page is mounted, and removes it on unmount. The
 * script is inserted as early in the head as possible so it loads before the
 * WorkWave Payments iframe.
 */

export default function useCsideScript() {
    useEffect(() => {
        const existing = document.querySelector<HTMLScriptElement>(
            `script[src="${CSIDE_SCRIPT_SRC}"]`
        );
        if (existing) {
            return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = CSIDE_SCRIPT_SRC;
        script.referrerPolicy = 'origin';

        document.head.insertBefore(script, document.head.firstChild);

        return () => {
            script.remove();
        };
    }, []);
}
